import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {BrickSnake2000} from "../../BrickSnake2000";
import {BrickSnake2000XWaysSymbol} from "../../reels/symbols/XWaysSymbol";
import {CollectorSymbol} from "../../reels/symbols/CollectorSymbol";

export class UpdateCollector implements SimplePresentation {

    name:string = "UpdateCollector";

    constructor() {
    }

    shouldRun():boolean {
        return this.getCollectorSymbol() != undefined;
    }

    public getCollectorSymbol():CollectorSymbol {
        return <CollectorSymbol>BrickSnake2000.freespinsReelView.getAllSymbols()
            .filter((sym) => sym.symbolName == "TA")[0];
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline({
            onStart: () => {
                controller.setSkipCallback(() => {tl.seek("End", false)});
            },
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish()
            }
        });

        const model = BrickSnake2000.model;
        const collectorSymbol = this.getCollectorSymbol();
        const position = model.getCollectorSymbolPosition();
        const newMultiplier = model.gameData.multiplierValuesAtStart[position.reelID][position.reelPosition];

        tl.add(() => {
            collectorSymbol.updateValue(newMultiplier);
            BrickSnake2000.freespinsReelView.setCollectCounter(newMultiplier);
            BrickSnake2000.soundPlayer.playSound("walletIncrease");
        })

        tl.add(() => {}, '>0.5');
        tl.addLabel("End")
    }
}
